import { inject, provideAppInitializer } from '@angular/core';
import { PingRedirectService } from './ping-redirect.service';

export function initializePingRedirect(pingRedirectService: PingRedirectService): void {
    if (pingRedirectService.isBackFromRedirect) {
        pingRedirectService.handleBackFromRedirect();
    }
}

export const PING_REDIRECT_INITIALIZER = provideAppInitializer(() => {
    initializePingRedirect(inject(PingRedirectService));
});
